import { getColumnFromId } from 'src/utils/filterHelper';
import { filterSortOptionsActivityAllLog } from '../utils/activityFilterConstants';
import { trimValues } from 'src/utils/common';
import { ActivityLogFilterType } from '../types/filterOptionsType';

export function allLogListReqData(
  filterOptions: ActivityLogFilterType,
  from?: string,
): URLSearchParams {
  const formData = new URLSearchParams();

  formData.append('draw', '1');
  from ? formData.append('length', '100') : '';
  formData.append('timezoneOffset', `${new Date().getTimezoneOffset()}`);

  const columns = [
    'DocId',
    'AccountId',
    'CreatedOn',
    'UserName',
    'Category',
    'CategoryActivity',
    'CID',
    'PID',
    'CreatedBy',
    'AccountList',
  ];

  const columnKeyMap: Record<string, keyof ActivityLogFilterType> = {
    DocId: 'docId',
    // AccountId: 'accountId',
    CreatedOn: 'createdOn',
    UserName: 'userName',
    Category: 'type',
    CategoryActivity: 'categoryActivity',
    CID: 'cid',
    PID: 'pid',
    CreatedBy: 'createdBy',
    AccountList: 'accountCidPid',
  };

  columns.forEach((col, index) => {
    const columnName = col === 'CategoryActivity' ? 'Activity' : col;
    formData.append(`columns[${index}][data]`, columnName);
    formData.append(`columns[${index}][name]`, '');
    formData.append(`columns[${index}][searchable]`, 'true');
    formData.append(`columns[${index}][orderable]`, 'true');
    formData.append(`columns[${index}][search][regex]`, 'false');
    formData.append(`columns[${index}][search][ApplyExactMatch]`, '');

    const key = columnKeyMap[col];
    const rawValue = key ? filterOptions[key] : undefined;

    let filterValue = '';

    if (typeof rawValue === 'string') {
      filterValue = trimValues(rawValue);
    } else if (col === 'Category' && Array.isArray(filterOptions.type)) {
      filterValue =
        filterOptions.type.length > 0
          ? filterOptions.type
              .map(t => trimValues(t.label ?? ''))
              .filter(label => label !== '')
              .join(', ')
          : '';
    } else if (col === 'CategoryActivity') {
      const hasType =
        Array.isArray(filterOptions.type) && filterOptions.type.length > 0;

      filterValue =
        hasType &&
        Array.isArray(filterOptions.categoryActivity) &&
        filterOptions.categoryActivity.length > 0
          ? filterOptions.categoryActivity
              .map(t => trimValues(t.label ?? ''))
              .filter(label => label !== '')
              .join(', ')
          : '';
    } else if (
      typeof rawValue === 'object' &&
      rawValue !== null &&
      'label' in rawValue
    ) {
      filterValue = trimValues((rawValue as { label: string }).label);
    }

    formData.append(`columns[${index}][search][value]`, filterValue);
  });

  formData.append(
    'order[0][column]',
    getColumnFromId(filterOptions.sortType, filterSortOptionsActivityAllLog),
  );
  formData.append('order[0][dir]', filterOptions.sortOrder);

  formData.append(
    'search[value]',
    `${trimValues(filterOptions.keywordSearch)}`,
  );
  formData.append('search[regex]', 'false');

  return formData;
}
